import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";

const MasterLayout = () => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const [anyDropdownOpen, setAnyDropdownOpen] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;
  const navigate = useNavigate();
  const loggedInUser = JSON.parse(localStorage.getItem("user"));
  let fullname = "";
  if (loggedInUser) {
    fullname = loggedInUser.Name.charAt(0) + loggedInUser.Surname.charAt(0);
  }
  console.log("user", user);

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          setTimeout(() => {
            submenu.style.maxHeight = `${submenu.scrollHeight + 10}px`;
          }, 0);
        }
        setAnyDropdownOpen(true);
      } else {
        setAnyDropdownOpen(false);
      }
    };

    // Handle click on regular menu items to clear dropdown state
    const handleRegularMenuClick = (event) => {
      // Close all dropdowns when clicking regular menu items
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px";
        }
      });
      setAnyDropdownOpen(false);
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    // Attach click event listeners to regular menu items
    const regularMenuItems = document.querySelectorAll(
      ".sidebar-menu > li:not(.dropdown) > a"
    );

    regularMenuItems.forEach((item) => {
      item.addEventListener("click", handleRegularMenuClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      let foundActive = false;
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            foundActive = true;
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              setTimeout(() => {
                submenu.style.maxHeight = `${submenu.scrollHeight + 10}px`;
              }, 0);
            }
          }
        });
      });
      setAnyDropdownOpen(foundActive);
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
      regularMenuItems.forEach((item) => {
        item.removeEventListener("click", handleRegularMenuClick);
      });
    };
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/sign-in");
  };

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/' className='sidebar-logo'>
            <img
              src='assets/images/SoksanLogo.png'
              alt='site logo'
              className='light-logo'
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>

            <li>
              <NavLink
                to='/'
                className={(navData) => (navData.isActive && !anyDropdownOpen ? "active-page" : "")}
              >
                <Icon icon='solar:home-smile-angle-outline' className='menu-icon' />
                <span>Dashboard</span>
              </NavLink>
            </li>

            {user?.IsUserManagementAllowed && (
              <>
                <li>
                  <NavLink
                    to='/admin-user'
                    className={(navData) => (navData.isActive && !anyDropdownOpen ? "active-page" : "")}
                  >
                    <Icon icon='mage:user' className='menu-icon' />
                    <span>User</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to='/country'
                    className={(navData) =>
                      navData.isActive && !anyDropdownOpen ? "active-page" : ""
                    }
                  >
                    <Icon icon='mdi:globe' className='menu-icon' />
                    Country
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to='/language'
                    className={(navData) =>
                      navData.isActive && !anyDropdownOpen ? "active-page" : ""
                    }
                  >
                    <Icon icon='mdi:language' className='menu-icon' />
                    Languages
                  </NavLink>
                </li>
              </>
            )}


            {user?.IsCropManagementAllowed && (
              <>
                <li className='dropdown'>
                  <Link
                    to='#'
                    onClick={(e) => e.preventDefault()}
                    className={
                      ["/phases", "/crop-master", "/pest", "/disease", "/pest-mapping", "/disease-mapping"].includes(location.pathname)
                        ? "active-page"
                        : ""
                    }
                  >
                    <Icon icon='mdi:wheat' className='menu-icon' />
                    <span>Crop Specific<br></br> Information</span>
                  </Link>

                  <ul className='sidebar-submenu'>
                    <li>
                      <NavLink
                        to='/phases'
                        className={(navData) => (navData.isActive ? "active-page" : "")}
                      >
                        <Icon icon='mdi:regenerative-agriculture' className='menu-icon' />
                        <span>Growth Phases</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/crop-master'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon icon='mdi:seed-plus' className='menu-icon' />
                        Crop Master
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/pest'
                        className={(navData) => (navData.isActive ? "active-page" : "")}
                      >
                        <Icon icon='mdi:bug' className='menu-icon' />
                        <span>Pest</span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/disease'
                        className={(navData) => (navData.isActive ? "active-page" : "")}
                      >
                        <Icon icon='mdi:virus' className='menu-icon' />
                        <span>Diseases</span>
                      </NavLink>
                    </li>



                    <li>
                      <NavLink
                        to='/pest-mapping'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon icon='mdi:ladybug' className='menu-icon' />
                        Crop - Pest Mapping
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/disease-mapping'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon icon='mdi:bacteria' className='menu-icon' />
                        Crop - Disease Mapping
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/cropwise-info'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon icon='mdi:seed' className='menu-icon' />
                        Crop Wise Common Information
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/cropwise-sowing'
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon icon='mdi:leaf-circle' className='menu-icon' />
                        Crop Wise Pre/Post Sowing
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <>

                  <li className='dropdown'>
                    <Link
                      to='#'
                      onClick={(e) => e.preventDefault()}
                      className={
                        ["/subject", "/general-information"].includes(location.pathname)
                          ? "active-page"
                          : ""
                      }
                    >
                      <Icon icon='mdi:wheat' className='menu-icon' />
                      <span>General <br></br> Information</span>
                    </Link>

                    <ul className='sidebar-submenu'>
                      <li>
                        <NavLink
                          to='/subject'
                          className={(navData) => (navData.isActive ? "active-page" : "")}
                        >
                          <Icon icon='mdi:regenerative-agriculture' className='menu-icon' />
                          <span>Subject</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to='/general-information'
                          className={(navData) =>
                            navData.isActive ? "active-page" : ""
                          }
                        >
                          <Icon icon='mdi:seed-plus' className='menu-icon' />
                          General Topic
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </>
              </>
            )}
<li>
              <NavLink
                to='/campaigns'
                className={(navData) =>
                  navData.isActive && !anyDropdownOpen ? "active-page" : ""
                }
              >
                <Icon icon='material-symbols:campaign-rounded' className='menu-icon' />
                Campaigns
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/livestock'
                className={(navData) =>
                  navData.isActive && !anyDropdownOpen ? "active-page" : ""
                }
              >
                <Icon icon='mdi:cow' className='menu-icon' />
                Livestock
              </NavLink>
            </li>
            <li>
              <NavLink
                to='/human-health'
                className={(navData) =>
                  navData.isActive && !anyDropdownOpen ? "active-page" : ""
                }
              >
                <Icon icon='mdi:hospital-box' className='menu-icon' />
                Human Health
              </NavLink>
            </li>

            {user?.IsReportAccessAllowed && (
              <li className='dropdown'>
                <Link
                  to='#'
                  onClick={(e) => e.preventDefault()}
                  className={
                    ["/farmer-list", "/city-wise-user-list-report", "/weather-api-usage-report"].includes(location.pathname)
                      ? "active-page"
                      : ""
                  }
                >
                  <Icon icon='mdi:file-chart' className='menu-icon' />
                  <span>Report</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/farmer-list'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Farmer List
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      to='/city-wise-user-list-report'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      City wise User List
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to='/weather-api-usage-report'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                      Weather API Usage
                    </NavLink>
                  </li> */}
                </ul>
              </li>
            )}



          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>

              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                {/* ThemeToggleButton */}
                <ThemeToggleButton />

                {/* Language dropdown end */}

                {/* Message dropdown end */}

                {/* Notification dropdown end */}

                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle w-40-px h-40-px object-fit-cover rounded-circle bg-gray-200 text-uppercase'
                    type='button'
                    data-bs-toggle='dropdown'
                    style={{ letterSpacing: '1px' }}
                  >
                    {fullname}
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2 text-capitalize'>
                          {`${user?.Name} ${user?.Surname}`}
                        </h6>
                        <span className='text-secondary-light fw-medium text-sm'>
                          Admin
                        </span>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>

                      <li>
                        <button
                          onClick={handleLogout}
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3 border-0 bg-transparent w-100 text-start'
                        >
                          <Icon icon='lucide:power' className='icon text-xl' />
                          Log Out
                        </button>

                      </li>
                    </ul>
                  </div>
                </div>  
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'><Outlet /></div>
      </main>
    </section>
  );
};

export default MasterLayout;